export const BILLING_PAGE = '/billing';
export const BILLING_DASHBOARD_PAGE = `${BILLING_PAGE}/dashboard`;
export const BILLING_TRANSACTIONS_PAGE = `${BILLING_PAGE}/transactions`;
export const BILLING_TOP_UP_RESULT = `${BILLING_PAGE}/top-up/result`;
export const BILLING_BONUSES = `${BILLING_PAGE}/bonus`;
